import React from "react";
import _ from "lodash";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Table, TableBody, TableCell, TableRow } from "@material-ui/core";

export default function AddRDCDialogContent({ data, children }) {
  const rdc = data.wallet.reservationOnly;
  const edc = data.wallet.earnedDealCoin;

  return (
    <Grid container={true} direction="column" style={{ width: 300 }}>
      <Grid item container direction="row">
        <Typography component="p">
          Status wallet {_.capitalize(data.username.replace("_", " "))}
        </Typography>
      </Grid>
      <Table style={{ width: "100%", marginBottom: 20 }}>
        <TableCell>EDC</TableCell>
        <TableCell>RDC</TableCell>
        <TableBody>
          <TableRow>
            <TableCell align="right">{edc}</TableCell>
            <TableCell align="right">{rdc}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Grid item container direction="column">
        <div>{children}</div>
      </Grid>
    </Grid>
  );
}
